import { Title, Description, Image } from 'common/components';
import { Glossary, PlanListGL } from 'common/utils/glossary';

import React from 'react';

interface Props {
  /** グロッサリ */
  glossary: Glossary;
}

/**
 * プラン一覧画面のヘッダー部のコンポーネント
 */
export const PlanListsHeder: React.FC<Props> = ({ glossary }) => {
  return (
    // CSSでIDのpageHeaderが指定されている
    <div id="pageHeader" data-test="planListsHeder">
      <Title type="title" data-test="headerTitle">
        {glossary.glx(PlanListGL.StoreTitle)}
      </Title>
      <Image
        type="keyVisual"
        imageSrc="plan-list/SAS_KV.png"
        data-test="headerKeyVisual"
      />
      <Description type="lead" data-test="headerDescription">
        {glossary.glx(PlanListGL.Lead)}
      </Description>
    </div>
  );
};
